import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { QuoteCouplerStyle } from '../../../quotes/quoteProductConfiguration';
import { CouplerTypes } from '../../../coupler-styles/couplerTypes';
import { CouplerStyleTypes } from '../../../coupler-styles/couplerStyleTypes';
import { CouplerOilReadyType } from '../../../coupler-styles/couplerStyle';
import { couplerDecision } from '../../../quotes/otherQuoteEntities';
import { makeConcealable } from '@ami/react/core';
import { TextMosaic, TextMosaicDto, MosaicWall } from '@ami/react/core';
import _ from 'lodash';

class ReviewQuoteExistingCouplerSelection extends React.Component {
  state = {
    type: null,
    style: null,
  };

  static propTypes = {
    couplerStyles: PropTypes.arrayOf(PropTypes.instanceOf(QuoteCouplerStyle))
      .isRequired,
    defaultCouplerType: PropTypes.string,
    defaultStyle: PropTypes.string,
    decision: PropTypes.string.isRequired,
    couplerStyleId: PropTypes.string,
    onCouplerStyleIdChanged: PropTypes.func.isRequired,
    couplerOilReady: PropTypes.string,
    onCouplerOilReadyChanged: PropTypes.func.isRequired,
    productGroupIdsPerType: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        productGroupIds: PropTypes.arrayOf(PropTypes.string).isRequired,
      })
    ).isRequired,
    isNarrowLayout: PropTypes.bool,
    currentManufacturer: PropTypes.string,
  };

  componentDidMount() {
    const type = this.getInitialType(this.props);
    const style = this.getInitialStyle(this.props, type);
    this.setState({ type, style });
  }

  getInitialType(props) {
    const { couplerStyles, couplerStyleId, defaultCouplerType, decision } =
      props;
    if (couplerStyleId) {
      return couplerStyles.find((x) => x.id === couplerStyleId).type;
    } else if (defaultCouplerType) {
      return defaultCouplerType;
    }
    const availableTypes = this.getAvailableCouplerTypes(decision);
    return availableTypes.length === 1 ? availableTypes[0].type : null;
  }

  getInitialStyle(props, type) {
    const {
      couplerStyles,
      couplerStyleId,
      defaultStyle,
      decision,
      currentManufacturer,
    } = props;
    if (couplerStyleId) {
      return couplerStyles.find((x) => x.id === couplerStyleId).style;
    } else if (defaultStyle) {
      return defaultStyle;
    }
    const availableStyles = this.getAvailableStyles(
      type,
      decision,
      currentManufacturer
    );
    return availableStyles.length === 1 ? availableStyles[0].id : null;
  }

  handleOnTypeChanged = (type) => {
    const { decision, currentManufacturer } = this.props;
    const availableStyles = this.getAvailableStyles(
      type,
      decision,
      currentManufacturer
    );
    const style = availableStyles.length === 1 ? availableStyles[0].id : null;

    this.setState({ type, style }, () => {
      this.props.onCouplerStyleIdChanged(null);
      this.props.onCouplerOilReadyChanged(null);
    });
  };

  handleOnStyleChanged = (style) => {
    this.setState({ style: style }, () => {
      this.props.onCouplerStyleIdChanged(null);
      this.props.onCouplerOilReadyChanged(null);
    });
  };

  getAvailableCouplerTypes(decision) {
    const couplerTypesArray = _.map(CouplerTypes, (label, type) => ({
      type,
      label,
    }));
    return couplerTypesArray.filter((x) =>
      this.props.couplerStyles.some(
        (y) =>
          y.type === x.type &&
          y.availableDecisionTypes.find(
            (decisionType) => decisionType === decision
          )
      )
    );
  }

  getAvailableStyles(type, decision, currentManufacturer) {
    const couplerStylesArray = _.map(CouplerStyleTypes, (label, id) => ({
      id,
      label,
    }));
    return couplerStylesArray.filter((x) =>
      this.props.couplerStyles.some(
        (y) =>
          y.style === x.id &&
          y.type === type &&
          y.availableDecisionTypes.find(
            (decisionType) => decisionType === decision
          ) &&
          (y.preferredMakes.length === 0 ||
            y.preferredMakes.includes(currentManufacturer))
      )
    );
  }

  getFilteredCouplerStyles = (couplerStyles) => {
    const { type, style } = this.state;
    const { decision, currentManufacturer } = this.props;
    var couplerStylesFilter = couplerStyles.filter(
      (x) =>
        type === x.type &&
        style === x.style &&
        x.availableDecisionTypes.find(
          (decisionType) => decisionType === decision
        ) &&
        (x.preferredMakes.length === 0 ||
          x.preferredMakes.includes(currentManufacturer))
    );
    couplerStylesFilter = couplerStylesFilter.sort((a, b) =>
      a.name.localeCompare(b.name)
    );
    couplerStylesFilter = couplerStylesFilter.sort((a, b) =>
      a.preferredMakes.includes(currentManufacturer) ? -1 : 1
    );
    return couplerStylesFilter;
  };

  render() {
    const {
      couplerStyles,
      defaultCouplerType,
      defaultStyle,
      couplerStyleId,
      onCouplerStyleIdChanged,
      couplerOilReady,
      onCouplerOilReadyChanged,
      decision,
      isNarrowLayout,
      currentManufacturer,
    } = this.props;
    const { type, style } = this.state;
    const availableTypes = this.getAvailableCouplerTypes(decision);
    const availableStyles = this.getAvailableStyles(
      type,
      decision,
      currentManufacturer
    );
    const selectedCouplerStyle = couplerStyles.find(
      (x) => x.id === couplerStyleId
    );

    return (
      <div className="row justify-content-center quote-lugging-selection">
        <div className={`col ${isNarrowLayout ? '' : 'col-md-8'}`}>
          {availableTypes.length > 1 && !defaultCouplerType && (
            <Fragment>
              <div className="row justify-content-center text-center mb-2">
                <h5>What type of lugging?</h5>
              </div>
              <div className="row text-center">
                <MosaicWall
                  childrenContainerClassName={`row d-flex justify-content-center ${
                    !type && 'invalid'
                  }`}
                  placeholder="Select a lugging type..."
                >
                  {availableTypes.map((x) => (
                    <TextMosaic
                      key={x.type}
                      data={
                        new TextMosaicDto({
                          label: x.label,
                          selected: type === x.type,
                        })
                      }
                      widthColumns={4}
                      mdWidthColumns={isNarrowLayout ? 4 : 3}
                      onClick={() => this.handleOnTypeChanged(x.type)}
                    />
                  ))}
                </MosaicWall>
              </div>
            </Fragment>
          )}
          {availableStyles.length > 1 && !defaultStyle && (
            <Fragment>
              <div className="row justify-content-center text-center mb-2">
                <h5>What brand?</h5>
              </div>
              <div className="row text-center mt-1">
                <MosaicWall
                  childrenContainerClassName={`row d-flex justify-content-center ${
                    couplerStyleId || decision === couplerDecision.notSpecified
                      ? ''
                      : 'invalid'
                  }`}
                  placeholder="Select a lugging style..."
                >
                  {availableStyles.map((x) => (
                    <TextMosaic
                      key={x.id}
                      data={
                        new TextMosaicDto({
                          label: x.label,
                          selected: style === x.id,
                        })
                      }
                      widthColumns={4}
                      mdWidthColumns={isNarrowLayout ? 4 : 3}
                      onClick={() => this.handleOnStyleChanged(x.id)}
                    />
                  ))}
                </MosaicWall>
              </div>
            </Fragment>
          )}
          {type && style && (
            <Fragment>
              <div className="row justify-content-center text-center mb-2">
                <h5>What lugging style?</h5>
              </div>
              <div className="row text-center mt-1">
                <MosaicWall
                  childrenContainerClassName={`row d-flex justify-content-center ${
                    couplerStyleId || decision === couplerDecision.notSpecified
                      ? ''
                      : 'invalid'
                  }`}
                  placeholder="Select a brand..."
                >
                  {this.getFilteredCouplerStyles(couplerStyles).map((x) => (
                    <TextMosaic
                      key={x.id}
                      data={
                        new TextMosaicDto({
                          label: x.name,
                          description: x.description,
                          selected: couplerStyleId === x.id,
                        })
                      }
                      onClick={() => onCouplerStyleIdChanged(x.id)}
                      active={couplerStyleId === x.id}
                      widthColumns={4}
                      mdWidthColumns={isNarrowLayout ? 4 : 3}
                    />
                  ))}
                </MosaicWall>
              </div>
            </Fragment>
          )}
          {selectedCouplerStyle &&
            selectedCouplerStyle.availableOilReadyTypes.length > 1 && (
              <Fragment>
                <div className="row justify-content-center text-center mb-2">
                  <h5>What oil readiness?</h5>
                </div>
                <div className="row text-center mt-1">
                  <MosaicWall
                    childrenContainerClassName={`row d-flex justify-content-center ${
                      couplerOilReady ? '' : 'invalid'
                    }`}
                    placeholder="Select an oil readiness..."
                  >
                    {selectedCouplerStyle.availableOilReadyTypes.map((x) => (
                      <TextMosaic
                        key={x}
                        data={
                          new TextMosaicDto({
                            label: CouplerOilReadyType[x],
                            selected: couplerOilReady === x,
                          })
                        }
                        onClick={() => onCouplerOilReadyChanged(x)}
                        active={couplerOilReady === x}
                        widthColumns={4}
                        mdWidthColumns={isNarrowLayout ? 4 : 3}
                      />
                    ))}
                  </MosaicWall>
                </div>
              </Fragment>
            )}
        </div>
      </div>
    );
  }
}

export default makeConcealable(ReviewQuoteExistingCouplerSelection);
